// Introduction Content for the 2-Week Window Period
// Content URLs mapped by language code

export const INTRODUCTION_CONTENT = {
  en: {
    title: 'Axiom Recovery Programme (ARP) - Introduction',
    subtitle: 'Module 1: Introduction to the Programme',
    pdfUrl: 'https://customer-assets.emergentagent.com/job_c2b961a8-ea8c-4dbb-ad47-155fcf8e5075/artifacts/fp9ws4m1_Axiom_%20ARP%20Introduction%20.pdf',
    language: 'English'
  },
  ru: {
    title: 'Программа восстановления Axiom (ARP) - Введение',
    subtitle: 'Модуль 1: Введение в программу',
    pdfUrl: 'https://customer-assets.emergentagent.com/job_c2b961a8-ea8c-4dbb-ad47-155fcf8e5075/artifacts/3g018axg_Axiom%3B%20Introduction%20-%20Russian.pdf',
    language: 'Russian'
  },
  ko: {
    title: 'Axiom 회복 프로그램 (ARP) - 소개',
    subtitle: '모듈 1: 프로그램 소개',
    pdfUrl: 'https://customer-assets.emergentagent.com/job_c2b961a8-ea8c-4dbb-ad47-155fcf8e5075/artifacts/pfuwuxnf_Axiom_%20Introduction%20-%20Korean.pdf',
    language: 'Korean'
  },
  uk: {
    title: 'Програма відновлення Axiom (ARP) - Вступ',
    subtitle: 'Модуль 1: Вступ до програми',
    pdfUrl: 'https://customer-assets.emergentagent.com/job_c2b961a8-ea8c-4dbb-ad47-155fcf8e5075/artifacts/q8ubc3kd_Axiom%3B%20Intrduction%20Ukraine.pdf',
    language: 'Ukrainian'
  },
  it: {
    title: 'Programma di recupero Axiom (ARP) - Introduzione',
    subtitle: 'Modulo 1: Introduzione al programma',
    pdfUrl: 'https://customer-assets.emergentagent.com/job_c2b961a8-ea8c-4dbb-ad47-155fcf8e5075/artifacts/40get0km_Axiom_%20Inroduction%20-%20Italian.pdf',
    language: 'Italian'
  },
  fr: {
    title: 'Programme de rétablissement Axiom (ARP) - Introduction',
    subtitle: 'Module 1: Introduction au programme',
    pdfUrl: 'https://customer-assets.emergentagent.com/job_c2b961a8-ea8c-4dbb-ad47-155fcf8e5075/artifacts/n3qqheut_Axiom_%20Introduction%20French.pdf',
    language: 'French'
  },
  es: {
    title: 'Programa de recuperación Axiom (ARP) - Introducción',
    subtitle: 'Módulo 1: Introducción al programa',
    pdfUrl: 'https://customer-assets.emergentagent.com/job_c2b961a8-ea8c-4dbb-ad47-155fcf8e5075/artifacts/f7apmzg6_Axiom_%20Introduction%20Spanish.pdf',
    language: 'Spanish'
  }
};

// Get content for user's selected language, fallback to English
export const getIntroductionContent = (langCode) => {
  const content = INTRODUCTION_CONTENT[langCode];
  
  // If content exists and has PDF, return it
  if (content && content.pdfUrl) {
    return content;
  }
  
  // Fallback to English
  return INTRODUCTION_CONTENT['en'];
};

// Check if content is available for a language
export const isContentAvailable = (langCode) => {
  const content = INTRODUCTION_CONTENT[langCode];
  return content && content.pdfUrl !== null;
};

export default INTRODUCTION_CONTENT;
